<template >
    <div class="header-tools-item" @click="$emit('click')">
        <button 
            class="header-tools-item__button button button_size_small button_color_transp-black button_with_icon"
            :class="{'button_type_active':this.$store.getters.barTrans.value}"
            @click="handlerClick"
            title="Транзакции"
        >
            <div class="header_button_icon header-tools-item__icon">
                <svg aria-hidden="true" width="20" height="20">
                    <use href="#icon-card-2"></use>
                    <use href="#icon-card"></use>
                </svg>
            </div>

            <div class="header-tools-item__text is-desktop-hide">
                Транзакции
            </div>
        </button>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    methods: {
        ...mapActions([
            'SET_BAR',
            'CHANGE_ACTIVE_BAR'
        ]),

        handlerClick() {
            const value = !this.$store.getters.barTrans.value
            this.CHANGE_ACTIVE_BAR({name:'trans', value})
            
        },
    },
}
</script>
<style lang="scss">
.header-tools-item {
    & &__button {
        margin-right: 0;
    }
}
</style>